import { render } from "./SubscriptionView.vue?vue&type=template&id=7cb06f16&scoped=true"
import script from "./SubscriptionView.vue?vue&type=script&lang=js"
export * from "./SubscriptionView.vue?vue&type=script&lang=js"

import "./SubscriptionView.vue?vue&type=style&index=0&id=7cb06f16&scoped=true&lang=css"

import exportComponent from "/home/runner/work/GPSviaAIS/GPSviaAIS/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb06f16"]])

export default __exports__